import React, { useEffect, useState } from 'react';
import { baseSales } from './base';
import { ListInterpreter } from '../../@core/components/interpreter/ListInterpreter';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useAsync } from '../../utility/hooks/useAsync';
import { serverRequest } from '../../utility/helpers/Axios/serverRequest';
import { setData } from '../../redux/actions/list';
import { useDispatch } from 'react-redux';

export const SaleList = (props) => {
  const { type } = useParams();
  const dispatch = useDispatch();

  const loadSaleList = async () => {
    return await serverRequest('sale', null, {
      filter: ['oportunity||$eq||false'],
    });
  };
  useAsync(
    loadSaleList,
    (sales = []) => {
      if (type) {
        dispatch(
          setData(
            'sale',
            sales.filter(({ saleProducts = [] }) =>
              saleProducts.some((s) => s.type === type),
            ),
          ),
        );
      } else {
        dispatch(setData('sale', sales));
      }
    },
    [type],
  );

  return <ListInterpreter {...baseSales} />;
};
